import { createSlice } from "@reduxjs/toolkit";
// import contentEnUS from "./../../lang/en-US.json";

const initialState: any = {
  reports: null
}; //contentEnUS; tobeupdated

export const contentSlice = createSlice({
  name: "content",
  initialState,
  reducers: {}
});

export default contentSlice.reducer;
